<template>
  <v-layout fill-height fluid style="min-height: 100vh; max-height: 100vh; height: 100%; width: 100%;" >
    <v-col class="pl-8 pr-8 base-background">
        <v-row class="header-title-text">
          <v-col class="ma-1 text-left">
            <img width="14" height="14" src="@/assets/icons/back-icon.png" class="mr-1" style="cursor: pointer;" @click="backToOverview()">
            <span class="header-title-text" style="font-size: 20px;">แก้ไขโครงสร้าง</span>
          </v-col>
          <v-col cols="12" sm="12" md="6" lg="2" class="pt-0 pb-0 d-flex align-center justify-end mt-1 ml-5 action-top-btn">
            <v-btn
              outlined
              color="#2BA197"
              class="ml-2 mr-2"
              @click="backToOverview()"
            >
              <span class="ra-text-in-button">
                ยกเลิก
              </span>
            </v-btn>
            <!-- <v-btn
              outlined
              color="#2BA197"
              class="ml-2 mr-2"
            >
              <span class="ra-text-in-button">
                จัดวางโครงสร้าง
              </span>
            </v-btn> -->
            <v-btn
              color="#2BA197"
              class="ml-2 white--text"
              elevation="0"
              style="margin-right: 0px;"
              :disabled="!allowSave"
              @click="saveEditStructure(false)"
            >
              <span class="ra-text-in-button">
                บันทึกการแก้ไข
              </span>
            </v-btn>
          </v-col>
        </v-row>
        <!-- focusIndex {{focusIndex}} -->
        <!-- focusData {{focusData}} -->
        <!-- {{JSON.stringify(this.structureItems).length}} {{JSON.stringify(this.structureItemsOrigin).length}} -->
        <v-row>
          <v-container class="mt-2 ra-border-button" style="min-height: 82vh; height: 82%; min-width: 100%; width: 100%;">
            <div class="object-background mt-3 pt-2 pl-10 pr-10 pb-0 ml-6 mr-6 text-center" justify="start">
              <v-row align="center" style="margin-top: 0px; margin-bottom: -15px;" v-show="true">
                <v-col cols="2" class="text-right" style="margin-top: 0px;">
                <span >บริษัท :</span>
                </v-col>
                <v-col cols="5" class="text-left">
                  <span class="text-no-wrap black--text text--darken-0" style="margin-top: 0px; font-size: 14px;">
                    {{structureItems.title || '-'}}
                  </span>
                </v-col>
              </v-row>
              <v-row class="mb-0" align="center" style="margin-top: -10px;" v-show="isExpand">
                <v-col cols="2" class="text-right" style="margin-top: -5px;">
                <span >ชื่อสายบังคับบัญชา :</span>
                </v-col>
                <v-col cols="4">
                  <v-autocomplete
                      v-model="focusData.type"
                      :items="itemStructures"
                      item-text="name"
                      item-value="name"
                      :background-color="allowFocusItem? 'white':'#FAFAFA'"
                      outlined
                      placeholder="เลือกประเภทงาน"
                      no-data-text="ไม่พบข้อมูล"
                      class="mt-2"
                      dense
                      :disabled="(listSelect==0 && !allowFocusItem) || focusData.lockEditOrg"
                    >
                    </v-autocomplete>
                </v-col>
                <v-col cols="4">
                  <v-text-field
                    v-model="focusData.title"
                    :background-color="allowFocusItem? 'white':'#FAFAFA'"
                    outlined
                    :disabled="!allowFocusItem || focusData.lockEditOrg"
                    placeholder="ระบุชื่อสายบังคับบัญชา"
                    no-data-text="ไม่พบข้อมูล"
                    class="mt-2"
                    dense
                    @keydown.space="preventLeadingSpace"
                  >
                  </v-text-field>
                </v-col>
              </v-row>
              <v-row style="margin-top: -25px;" align="center" v-show="isExpand">
                <v-col cols="2" class="text-right" >
                  <v-checkbox
                    style="margin-top: 6px; margin-left: 15%;"
                    color="#2BA197"
                    v-model="focusData.orgChartHeader"
                    :disabled="!allowFocusItem || focusData.lockEditOrg"
                    @change="toggleLeader()"
                  >
                  <template #append>
                    <span class="text-no-wrap black--text text--darken-0" style="margin-top: 5px; font-size: 15.5px;">ผู้บังคับบัญชา : </span>
                  </template>
                  </v-checkbox>
                </v-col>
                <v-col cols="4">
                  <v-autocomplete
                      v-model="focusData.leaderId"
                      :items="itemLeaders"
                      item-text="dataShow"
                      item-value="employee_id"
                      return-object
                      outlined
                      placeholder="ค้นหาผู้บังคับบัญชา"
                      no-data-text="ไม่พบข้อมูล"
                      class="mt-2"
                      dense
                      :background-color="focusData.orgChartHeader? 'white':'#FAFAFA'"
                      :disabled="!focusData.orgChartHeader || focusData.lockEditOrg"
                      @keyup="getSelectLeader($event.target.value)"
                      @change="selectedLeader()"
                    >
                    </v-autocomplete>
                </v-col>
                <v-col cols="4">
                  <v-text-field
                    v-model="focusData.position"
                    outlined
                    placeholder="ตำแหน่ง"
                    no-data-text="ไม่พบข้อมูล"
                    class="mt-2"
                    dense
                    disabled
                  >
                  </v-text-field>
                </v-col>
                <v-col cols="2">
                  <v-checkbox
                    v-model="focusData.leaderTemp"
                    color="#2BA197"
                    outlined
                    :class="focusData.leaderTemp? 'border-black-box-checked pt-3 ml-0':'border-black-box pt-3 ml-0'"
                    style="height: 36px; margin-top: -7px; padding-left: 10px;"
                    height="12"
                    :disabled="!focusData.orgChartHeader || focusData.lockEditOrg"
                  >
                  <template v-slot:label>
                    <span class="text-no-wrap grey--text text--darken-1 pr-2 ma-0 pa-0 mt-0" style="font-size: 14px;">รักษาการแทน</span>
                  </template>
                  </v-checkbox>
                </v-col>
              </v-row>
              <v-divider class="" style="margin-top: -10px;" v-show="isExpand"/>
              <v-row class="mb-0"  align="center" style="margin-top: -10px;" v-show="isExpand">
                <v-col cols="2" class="text-right" >
                <!-- <span >ประเภท :</span> -->
                  <v-btn
                      color="#2BA197"
                      class="mt-2"
                      elevation="0"
                      :disabled="!focusIndex || focusData.lockEditOrg"
                      block
                      outlined
                      @click="showAddNew = !showAddNew"
                    >
                      <span class="ra-text-in-button" style="white-space: normal; letter-spacing: 0.4px;">
                        เพิ่มสายบังคับบัญชา
                      </span>
                    </v-btn>
                </v-col>
                <v-col cols="6">
                </v-col>
                <v-col cols="2">
                  <v-btn
                    outlined
                    color="#2BA197"
                    class="mt-2"
                    block
                    :disabled="!focusIndex || focusData.lockEditOrg"
                    v-if="focusIndex!==topIndex"
                    @click="promtDialogRemove = true"
                  >
                    <span class="ra-text-in-button" style="white-space: normal; letter-spacing: 0.4px;">
                      ลบสายบังคับบัญชา
                    </span>
                  </v-btn>
                </v-col>
                <v-col cols="2">
                  <v-btn
                    color="#2BA197"
                    class="mt-2 white--text"
                    elevation="0"
                    :disabled="!allowSaveFocusStucture"
                    block
                    @click="saveFocusStucture()"
                  >
                    <span class="ra-text-in-button" style="white-space: normal; letter-spacing: 0.4px;">
                      แก้ไขเรียบร้อย
                    </span>
                  </v-btn>
                </v-col>
              </v-row>
              <v-row align="center" justify="end">
                <a
                  class="mr-0"
                  @click="isExpand = !isExpand"
                  :style="`text-decoration-line: underline; ${!isExpand? 'margin-top: -20px; margin-bottom: 15px; color: #2BA197;':'margin-bottom: 5px; color: #2BA197;'}`"
                >{{isExpand? 'แสดงผลน้อยลง':'แสดงผลมากขึ้น'}}</a>
                <v-icon
                  dark
                  color="#2BA197"
                  :style="`${!isExpand? 'margin-top: -20px; margin-bottom: 15px;':'margin-bottom: 5px; '}`"
                >{{isExpand? 'mdi-chevron-up':'mdi-chevron-down'}}</v-icon>
              </v-row>
            </div>
            <!-- <pre>{{ JSON.stringify(structureItems, null, '\t') }}</pre> -->
            <OverlayLoading :loading="loading" />
            <OrgChart :dataChart="structureItems" :isExpand="isExpand" class="mt-3 ml-6 mr-6 mb-3 object-background" v-if="true"/>
          </v-container>
        </v-row>
    </v-col>
    <v-dialog
      v-model="promtDialog"
      persistent
      max-width="385"
      max-height="500"
      style="z-index: 9999"
    >
      <v-card tile class="justify-center">
        <v-card-title class="justify-center">
          <span style="font-family: Sarabun; font-style: normal; font-weight: bold; font-size: 16px; line-height: 22px; text-align: center; color: #3776E9;">
            ต้องการออกจากหน้านี้ใช่ไหม
          </span>
        </v-card-title>
        <v-card-subtitle class="layout justify-center pt-1">
          <span style="font-family: Sarabun; font-style: normal; font-weight: 400; font-size: 16px; line-height: 22px; text-align: center; color: #757575; margin-top: 12px;">
            ข้อมูลของคุณยังไม่ถูกบันทึก <br> คุณแน่ใจหรือไม่ว่าต้องการออกจากหน้านี้
          </span>
        </v-card-subtitle>
        <div class="justify-center">
          <v-btn
            v-if="changePageStatus==='newItemBlank'"
            color="#2BA197"
            class="head-search-button ml-10 mt-2 mb-2 white--text text--lighten-4"
            width="290"
            @click="submitPromt('leave'), promtDialog = false"
          >
          ตกลง ฉันจะออกจากหน้านี้
          </v-btn>
          <v-btn
            v-if="changePageStatus==='newItemCanSave'"
            color="#2BA197"
            class="head-search-button ml-10 mt-2 mb-2 white--text text--lighten-4"
            width="290"
            @click="submitPromt('saveAndLeave'), promtDialog = false"
          >
          ฉันแน่ใจ และบันทึกข้อมูล
          </v-btn>
          <v-btn
            v-if="changePageStatus==='newItemBlank'"
            color="#2BA197"
            outlined
            class="head-search-button ml-10 mt-2 mb-2"
            width="290"
            @click="submitPromt('cancel'), promtDialog = false"
          >
          ไม่ ฉันจะอยู่ต่อหน้านี้
          </v-btn>
          <v-btn
            v-if="changePageStatus==='newItemCanSave'"
            color="#2BA197"
            outlined
            class="head-search-button ml-10 mt-2 mb-2"
            width="290"
            @click="submitPromt('leaveAndChangeTab'), promtDialog = false"
          >
          ฉันแน่ใจ และไม่บันทึกข้อมูล
          </v-btn>
          <v-btn
            v-if="changePageStatus!=='newItemBlank'"
            color="#2BA197"
            class="ml-10 mt-2 mb-2 black--text text--lighten-4"
            width="290"
            text
            @click="submitPromt('cancel'), promtDialog = false"
          >
          ยกเลิก
          </v-btn>
        </div>
        <v-card-actions class="">
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog
      v-model="promtDialogSave"
      persistent
      max-width="385"
      max-height="500"
      style="z-index: 9999"
    >
      <v-card tile class="justify-center">
        <v-card-title class="justify-center">
          <span style="margin-top: 10px; font-family: Sarabun; font-style: normal; font-weight: bold; font-size: 16px; line-height: 22px; text-align: center; color: #3776E9;">
            ต้องการบันทึกข้อมูล{{currentTypeTH}}ใช่ไหม
          </span>
        </v-card-title>
        <v-card-subtitle class="layout justify-center pt-1">
          <span style="font-family: Sarabun; font-style: normal; font-weight: 400; font-size: 16px; line-height: 22px; text-align: center; color: #757575; margin-top: 12px;">
            คุณแน่ใจหรือไม่ว่าต้องการบันทึกข้อมูล{{currentTypeTH}}
          </span>
        </v-card-subtitle>
        <div class="justify-center">
          <v-btn
            color="#2BA197"
            class="head-search-button ml-10 mt-2 mb-2 white--text text--lighten-4"
            width="310"
            @click="submitPromt('saveAndBackToOverview'), promtDialogSave = false"
          >
          บันทึก และกลับไปหน้าจัดการโครงสร้างบริษัท
          </v-btn>
          <v-btn
            color="#2BA197"
            class="head-search-button ml-10 mt-2 mb-2"
            width="310"
            elevation="0"
            outlined
            @click="submitPromt('saveAndStay'), promtDialogSave = false"
          >
          บันทึก และอยู่หน้านี้ต่อ
          </v-btn>
          <v-btn
            color="#2BA197"
            class="ml-10 mt-2 mb-2 black--text text--lighten-4"
            width="300"
            text
            @click="submitPromt('cancel'), promtDialogSave = false"
          >
          ยกเลิก
          </v-btn>
        </div>
        <v-card-actions class="">
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog
      v-model="promtDialogRemove"
      persistent
      max-width="320"
      max-height="500"
      style="z-index: 9999"
    >
      <v-card tile class="justify-center">
        <v-card-title class="justify-center">
          <span style="margin-top: 10px; font-family: Sarabun; font-style: normal; font-weight: bold; font-size: 16px; line-height: 22px; text-align: center; color: #2BA197;">
            ต้องการลบข้อมูลใช่ไหม
          </span>
        </v-card-title>
        <v-card-subtitle class="layout justify-center pt-1">
          <span style="font-family: Sarabun; font-style: normal; font-weight: 400; font-size: 16px; line-height: 22px; text-align: center; color: #757575; margin-top: 12px;">
            คุณแน่ใจหรือไม่ว่าต้องการลบข้อมูล<br>
            และข้อมูลที่มีความสัมพันธ์กันถัดลงไป<br>
            จะถูกลบไปด้วย
          </span>
        </v-card-subtitle>
        <v-card-actions class="">
          <v-spacer></v-spacer>
          <v-btn class="mr-4 mb-4" color="#2BA197" width="100" dark @click="promtDialogRemove = false" outlined>ยกเลิก</v-btn>
          <v-btn class="ml-4 mb-4" color="#2BA197" width="100" dark @click="removeStructureItem(), promtDialogRemove = false">ตกลง</v-btn>
          <v-spacer></v-spacer>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-snackbar
      v-model="snackbar"
      :timeout="2000"
      top
      centered
      elevation="1"
      color="#ECF8EA"
      app
    >
      <v-icon dark color="#58A144" >mdi-check-circle-outline</v-icon>
      <span style="font-family: Sarabun; font-style: normal; font-weight: 400; font-size: 16px; line-height: 22px; text-align: center; color: #58A144;">
        คุณได้ทำการเพิ่มสายบังคับบัญชาการเรียบร้อยแล้ว
      </span>
    </v-snackbar>
    <v-snackbar
      v-model="snackbarRemove"
      :timeout="2000"
      top
      centered
      elevation="1"
      color="#ECF8EA"
      app
    >
      <v-icon dark color="#58A144" >mdi-check-circle-outline</v-icon>
      <span style="font-family: Sarabun; font-style: normal; font-weight: 400; font-size: 16px; line-height: 22px; text-align: center; color: #58A144;">
        คุณได้ทำการลบสายบังคับบัญชาการเรียบร้อยแล้ว
      </span>
    </v-snackbar>
    <DialogShowChart :type="currentTypeTH" :isShow="showPreview"/>
    <DialogAddNewStucture
      :topIndex="topIndex? topIndex.toString():'' || ''"
      :focusIndex="focusIndex? focusIndex.toString():'' || ''"
      :dialogShowAddNew="showAddNew"
      :itemLeaders="itemLeaders"
      :itemStructures="itemStructures"
      v-if="showAddNew"
      @closeDialogAddNewStucture="showAddNew=false"
      @submitAddNewStucture="submitAddNewStucture($event)"
    ></DialogAddNewStucture>
    <DialogShowDetailOnEdit
      :dialogShow="showDetailOnEdit"
      :itemReq="itemReq"
      :itemApprovers="itemApprovers"
      :company="companyForModal"
      @closeDialogShowDetailOnEdit="showDetailOnEdit=false"
    ></DialogShowDetailOnEdit>
  </v-layout>
</template>

<script>
import {
  // getSelectCompany,
  // searchLeader,
  getUserByEmployee,
  getSelectCompanyHeader, getOrgChartData, updateOrgChart, reqEditOrgChart
} from '@/API/API'
import { EventBus } from '@/EventBus'
import DialogShowChart from '../_dialog/dialogShowChart'
import DialogAddNewStucture from '../_dialog/dialongAddNewStucture'
import DialogShowDetailOnEdit from '../_dialog/dialogShowDetailOnEdit'
import OrgChart from '../_update/orgchart'
import OverlayLoading from '../../_template/OverlayLoading.vue'
export default {
  name: 'main-create-structure',
  components: {
    DialogShowChart,
    DialogAddNewStucture,
    DialogShowDetailOnEdit,
    OverlayLoading,
    OrgChart
  },
  data () {
    return {
      listCompare: { 0: 'สายงาน', 1: 'ฝ่ายงาน', 2: 'ส่วนงาน', 3: 'หน่วยงาน', 4: 'กลุ่มงาน' },
      listSelect: 0,
      targetListSelect: 3,
      isExpand: true,
      addedStucture: false,
      promtDialog: false,
      promtDialogSave: false,
      promtDialogRemove: false,
      dataChanged: false,
      snackbar: false,
      snackbarRemove: false,
      showPreview: false,
      showAddNew: false,
      showDetailOnEdit: false,
      selectedCompany: '',
      itemCompanyName: [],
      selectedStructure: 0,
      itemStructures: [
        { no: 0, name: 'สายงาน' },
        { no: 1, name: 'ฝ่ายงาน' },
        { no: 2, name: 'ส่วนงาน' },
        { no: 3, name: 'หน่วยงาน' },
        { no: 4, name: 'กลุ่มงาน' }
      ],
      itemStructuresOrigin: [
        { no: 0, name: 'สายงาน' },
        { no: 1, name: 'ฝ่ายงาน' },
        { no: 2, name: 'ส่วนงาน' },
        { no: 3, name: 'หน่วยงาน' },
        { no: 4, name: 'กลุ่มงาน' }
      ],
      itemStructureHead: [],
      itemLeaders: [],
      structureMain: null,
      structureItems: {},
      structureItemsOrigin: {},
      structureForAdd: {},
      searchLeader: '',
      topIndex: null,
      focusIndex: null,
      focusData: {
        id: '',
        pid: null,
        title: '',
        type: null,
        typeAdd: null,
        orgChartLeader: null,
        orgChartHeader: false,
        searchLeader: null,
        leaderName: null,
        leaderPosition: null,
        leaderEmployeeId: null,
        leaderTemp: false,
        children: []
      },
      focusDataOrigin: {},
      hostStructure: null,
      moveStructure: null,
      companyId: null,
      loading: false,
      itemReq: {},
      itemApprovers: [],
      companyForModal: ''
    }
  },
  async created () {
    this.loading = true
    this.listSelect = 0
    this.companyId = this.$route.params.id
    // await this.getLeaderlist(this.currentTypeTH) // ปิด 5/4/66
    // await this.getCompanyList() // ปิด 5/4/66
    await this.getChartData()
    await this.getSelectLeader() // ปิดเทส
    // await this.modifyKeys(this.structureItems)
    await this.setBaseStructure()
    await this.resetFocusData()
    this.selectedStructure = this.listSelect
    this.loading = false
  },
  mounted () {
    EventBus.$on('closeDialogShowChart', this.closeShowPreview)
    EventBus.$on('changeFocusIndex', async (e) => {
      if (e) {
        var praseData = JSON.parse(JSON.stringify(e))
        praseData.orgChartHeader = !!praseData.leaderId
        this.focusIndex = praseData.id
        this.focusData = praseData
        this.focusDataOrigin = JSON.parse(JSON.stringify(this.focusData))
        if (this.focusData.leaderId) {
          this.getSelectLeaderClick(this.focusData.leaderId)
        }
      } else {
        await this.resetFocusData()
      }
    })
    EventBus.$on('moveStucture', async (e) => {
      if (e) {
        await this.moveStucture(e)
      }
    })
    EventBus.$on('saveFocusStucture', async (e) => {
      if (e) {
        // await this.moveStucture(e)
      }
    })
  },
  beforeDestroy (to, from, next) {
    // console.log('beforeDestroy')
    EventBus.$off('closeDialogShowChart')
    EventBus.$off('changeFocusIndex')
    EventBus.$off('moveStucture')
    this.promtDialog = true
  },
  computed: {
    allowNew () {
      // var result = (this.selectedCompany === '')
      //   ? false : (this.selectedCompany !== '') && this.structureItems.length === 0
      //     ? true : !!this.allowSave
      var result = this.selectedCompany !== ''
      return result
    },
    allowSave () {
      // var result = (this.structureItems.filter(x => x.orgChartName === '').length === 0 && this.structureItems.filter(x => x.orgChartPid === '').length === 0 && this.structureItems.filter(x => (x.orgChartHeader === true && !x.searchLeader)).length === 0) && this.structureItems.length > 0
      var result = !this.allowSaveFocusStucture && (JSON.stringify(this.structureItems) !== JSON.stringify(this.structureItemsOrigin))
      return result
    },
    allowSaveFocusStucture () {
      var result = (JSON.stringify(this.focusData) !== JSON.stringify(this.focusDataOrigin)) && this.focusData.title && (!((this.focusData.orgChartHeader === true && !this.focusData.leaderId)))
      return result
    },
    allowFocusItem () {
      return (this.focusIndex !== null && this.focusIndex !== 0 && this.focusIndex !== this.topIndex)
    },
    currentTypeTH () {
      return this.listCompare[this.listSelect]
    },
    changePageStatus () {
      if (this.structureItems.length > 0 && !this.allowSave) {
        return 'newItemBlank'
      } else if (this.structureItems.length > 0 && this.allowSave) {
        return 'newItemCanSave'
      } else {
        return false
      }
    }
  },
  methods: {
    // ป้องกันการกรอก Spacebar
    preventLeadingSpace (e) {
      // ป้องกันการกด spacebar ถ้ายังไม่มีการกรอกข้อมูล
      if (!e.target.value) e.preventDefault()
      // ถ้าหากอักขระนำหน้าเป็นช่องว่าง ให้ลบช่องว่างนำหน้าทั้งหมดออก
      else if (e.target.value[0] === ' ') e.target.value = e.target.value.replace(/^\s*/, '')
    },
    closeShowPreview () {
      // console.log('create closeShowPreview')
      this.showPreview = false
    },
    async getChartData () {
      const token = this.$store.state.token
      try {
        const res = await getOrgChartData(this.companyId, token)
        if (res.success) {
          if (res.result) {
            // console.log(res.result)
            this.structureItems = res.result
            this.structureItemsOrigin = JSON.parse(JSON.stringify(this.structureItems))
            this.topIndex = this.companyId
          }
        } else {
        }
      } catch (error) {
      } finally {
      }
    },
    // ปิด 5/4/66
    // async getCompanyList () {
    //   const token = this.$store.state.token
    //   try {
    //     const res = await getSelectCompany(token)
    //     if (res.success) {
    //       if (res.result.length) {
    //         this.itemCompanyName = res.result
    //       }
    //     } else {
    //     }
    //   } catch (error) {
    //   } finally {
    //   }
    // },
    // end
    async getSelectCompanyHeaderList (type) {
      var payload = { companyId: this.selectedCompany, orgChartType: type }
      const token = this.$store.state.token
      try {
        const res = await getSelectCompanyHeader(payload, token)
        if (res.success) {
          if (res.result) {
            var result = res.result
            if (type === 'สายงาน') {
              result.push({
                orgChartName: 'ไม่มี',
                _id: null
              })
            }
            return result
          }
        }
      } catch (error) {
        return []
      } finally {
      }
    },
    // ปิด 5/4/66
    // async getLeaderlist (type) {
    //   var payload = { companyId: this.selectedCompany, orgChartType: type }
    //   const token = this.$store.state.token
    //   try {
    //     const res = await searchLeader(payload, token)
    //     if (res.success) {
    //       if (res.result.length) {
    //         this.itemLeaders = res.result
    //       }
    //     } else {
    //     }
    //   } catch (error) {
    //     this.itemLeaders = []
    //   } finally {
    //   }
    // },
    // end
    async getSelectLeaderClick (employeeid) {
      var temp = []
      const payload = {
        employee_id: employeeid
      }
      const token = this.$store.state.token
      try {
        const res = await getUserByEmployee(payload, token)
        if (res.success) {
          if (res.selector.length) {
            res.selector.map((el, index) => {
              temp.push({
                dataShow: el.employeeId + ' - ' + el.titleTh + el.name,
                ...el
              })
            })
            this.itemLeaders = temp
            // console.log('ค้นหาจาก employee', this.itemLeaders)
          }
        } else {
          console.log('ไม่สำเร็จ')
        }
      } catch (error) {
        console.log(error)
        this.itemLeaders = []
      } finally {
      }
    },
    async getSelectLeader (value) {
      var temp = []
      var dataobj
      if (value) {
        const payload = {
          companyId: this.companyId,
          name: value
        }
        dataobj = payload
      } else {
        const payload = {
          companyId: this.companyId,
          name: ''
        }
        dataobj = payload
      }
      const token = this.$store.state.token
      try {
        const res = await getUserByEmployee(dataobj, token)
        if (res.success) {
          if (res.selector.length) {
            res.selector.map((el, index) => {
              temp.push({
                dataShow: el.employeeId + ' - ' + el.titleTh + el.name,
                ...el
              })
            })
            this.itemLeaders = temp
            // console.log('lfdfl==', this.itemLeaders)
          }
        } else {
        }
      } catch (error) {
        this.itemLeaders = []
      } finally {
      }
    },
    async changedCompany () {
      // for (const index in this.structureItems) {
      //   this.structureItems[index].orgChartPid = ''
      //   this.structureItems[index].itemStructureHead = await this.getSelectCompanyHeaderList(this.listCompare[this.structureItems[index].selectedStructure])
      // }
    },
    async changedStructureType (index) {
      this.structureItems[index].orgChartPid = ''
      this.structureItems[index].itemStructureHead = await this.getSelectCompanyHeaderList(this.listCompare[this.structureItems[index].selectedStructure])
    },
    selectedLeader () {
      var tempLeader = JSON.parse(JSON.stringify(this.focusData.leaderId))
      this.focusData.name = tempLeader.titleTh + tempLeader.firstNameTh + ' ' + tempLeader.lastNameTh
      this.focusData.position = tempLeader.position
      this.focusData.leaderId = tempLeader.employee_id
    },
    toggleLeader () {
      if (this.focusData.orgChartHeader === false) {
        this.focusData.searchLeader = null
        this.focusData.name = null
        this.focusData.position = null
        this.focusData.leaderId = null
        this.focusData.leaderTemp = false
      }
    },
    async setBaseStructure () {
      this.structureForAdd = {
        id: Math.floor(100000 + Math.random() * 900000),
        pid: null,
        title: '',
        type: null,
        typeAdd: null,
        orgChartLeader: null,
        orgChartHeader: false,
        searchLeader: null,
        leaderName: null,
        leaderPosition: null,
        leaderEmployeeId: null,
        leaderTemp: false,
        children: []
      }
    },
    async addStructureMain () {
      this.structureMain = {
        id: this.selectedCompany._id,
        title: this.selectedCompany.companyFullNameTh,
        pid: null,
        type: 'company',
        typeAdd: null,
        children: []
      }
      this.structureItems = this.structureMain
      this.addedStucture = true
      this.focusIndex = this.selectedCompany._id
      this.topIndex = this.selectedCompany._id
    },
    async resetFocusData () {
      this.focusIndex = null
      this.focusData = {
        id: '',
        pid: null,
        title: '',
        type: null,
        typeAdd: null,
        orgChartLeader: null,
        orgChartHeader: false,
        searchLeader: null,
        leaderName: null,
        leaderPosition: null,
        leaderEmployeeId: null,
        leaderTemp: false,
        children: []
      }
      this.focusDataOrgin = {
        id: '',
        pid: null,
        title: '',
        type: null,
        typeAdd: null,
        orgChartLeader: null,
        orgChartHeader: false,
        searchLeader: null,
        leaderName: null,
        leaderPosition: null,
        leaderEmployeeId: null,
        leaderTemp: false,
        children: []
      }
    },
    async submitAddNewStucture (newData) {
      // console.log('newData', newData)
      var genID = Math.floor(100000 + Math.random() * 900000)
      await this.findHostStructure(this.structureItems, this.focusIndex)
      var structureHost = this.hostStructure
      // console.log(newData.type, newData, this.focusIndex, 'structureHost', structureHost)
      if (newData.typeAdd === 'parent') {
        var pidTemp = structureHost.pid
        structureHost.pid = genID
        var newStructureParent = {
          id: genID,
          pid: pidTemp,
          title: newData.title,
          type: newData.type,
          typeAdd: newData.typeAdd,
          leaderId: newData.leaderId,
          searchLeader: newData.orgChartHeader ? newData.searchLeader : null,
          leaderTemp: newData.leaderTemp,
          name: newData.name,
          position: newData.position,
          children: [JSON.parse(JSON.stringify(structureHost))]
        }
        structureHost.id = newStructureParent.id
        structureHost.pid = newStructureParent.pid
        structureHost.title = newStructureParent.title
        structureHost.type = newStructureParent.type
        structureHost.typeAdd = newStructureParent.typeAdd
        structureHost.leaderId = newStructureParent.leaderId
        structureHost.searchLeader = newStructureParent.searchLeader
        structureHost.leaderTemp = newStructureParent.leaderTemp
        structureHost.name = newData.name
        structureHost.position = newData.position
        structureHost.children = newStructureParent.children
      } else if (newData.typeAdd === 'child') {
        if (!structureHost.children) structureHost.children = []
        structureHost.children.push({
          id: genID,
          pid: this.focusIndex,
          title: newData.title,
          type: newData.type,
          typeAdd: newData.typeAdd,
          leaderId: newData.leaderId,
          searchLeader: newData.orgChartHeader ? newData.searchLeader : null,
          leaderTemp: newData.leaderTemp,
          name: newData.name,
          position: newData.position,
          children: []
        })
      }
      await this.resetFocusData()
      // this.structureItems = JSON.parse(JSON.stringify(this.structureItems))
      await EventBus.$emit('rerenderOrgnChart', this.structureItems)
      this.showAddNew = false
      this.snackbar = true
    },
    async removeStructureItem () {
      await this.findHostStructure(this.structureItems, this.focusIndex)
      var structureHost = this.hostStructure
      await this.findHostStructure(this.structureItems, (structureHost.pid || this.topIndex))
      var structureParent = this.hostStructure
      if (!structureParent.children) structureParent.children = []
      structureParent.children = structureParent.children.filter(e => e.id !== this.focusIndex)
      await EventBus.$emit('rerenderOrgnChart', this.structureItems)
      await this.resetFocusData()
      this.snackbarRemove = true
    },
    async moveStucture (value) {
      console.log('id', value.from, 'move to pid', value.to)
      await this.findMoveStructure(this.structureItems, value.from)
      var structureMove = this.moveStructure
      await this.findMoveStructure(this.structureItems, value.to)
      var structureMoveTo = this.moveStructure
      await this.findMoveStructure(this.structureItems, (structureMove.pid || this.topIndex))
      var structureParent = this.moveStructure
      if (!structureMoveTo.children) structureMoveTo.children = []
      structureMoveTo.children.push({
        id: value.from,
        pid: value.to,
        title: structureMove.title,
        type: structureMove.type,
        typeAdd: structureMove.typeAdd,
        leaderId: structureMove.leaderId,
        name: structureMove.name,
        position: structureMove.position,
        searchLeader: structureMove.leaderId ? structureMove.searchLeader : null,
        leaderTemp: structureMove.leaderTemp,
        children: structureMove.children
      })
      if (!structureParent.children) structureParent.children = []
      structureParent.children = structureParent.children.filter(e => e.id.toString() !== structureMove.id.toString()) || []
      await EventBus.$emit('rerenderOrgnChart', this.structureItems)
    },
    async saveFocusStucture () {
      await this.findHostStructure(this.structureItems, this.focusIndex)
      var focusData = JSON.parse(JSON.stringify(this.focusData))
      var structureHost = this.hostStructure
      structureHost.title = focusData.title
      structureHost.type = focusData.type
      structureHost.leaderId = focusData.leaderId
      structureHost.name = focusData.name
      structureHost.position = focusData.position
      structureHost.searchLeader = focusData.searchLeader
      structureHost.leaderTemp = focusData.leaderTemp
      structureHost.orgChartHeader = focusData.orgChartHeader
      // console.log('saved focusData', focusData)
      // console.log('saved structureHost', structureHost)
      await this.resetFocusData()
      await EventBus.$emit('rerenderOrgnChart', this.structureItems)
    },
    async findHostStructure (obj, focusIndex) {
      for (var key in obj) {
        if (obj[key] !== null) {
          if (key === 'id' && obj.id !== null) {
            if (obj.id.toString() === focusIndex.toString()) {
              this.hostStructure = obj
              break
            }
          }
          if (typeof obj[key] === 'object') {
            await this.findHostStructure(obj[key], focusIndex)
          }
        }
      }
    },
    async findMoveStructure (obj, focusIndex) {
      for (var key in obj) {
        if (obj[key] !== null) {
          if (key === 'id' && obj.id !== null) {
            if (obj.id.toString() === focusIndex.toString()) {
              this.moveStructure = obj
              break
            }
          }
          if (typeof obj[key] === 'object') {
            await this.findMoveStructure(obj[key], focusIndex)
          }
        }
      }
    },
    changeMainType (page) {
      this.targetListSelect = page
      if (page !== this.listSelect) {
        this.itemStructures = this.itemStructuresOrigin.slice(0, (page + 1))
        if (this.structureItems.length) this.promtDialog = true
        else this.submitPromt('leaveAndChangeTab')
      }
    },
    async submitPromt (action) {
      if (action === 'saveAndLeave') {
        await this.saveEditStructure(false)
        this.listSelect = this.targetListSelect
        this.selectedStructure = this.listSelect
        this.structureItems = []
        this.$router.push(`/managestructure/create/${this.listSelect}`)
      } else if (action === 'saveAndBackToOverview') {
        await this.saveEditStructure(false)
        this.$router.push('/managestructure')
      } else if (action === 'leave' || action === 'leaveAndChangeTab') {
        this.listSelect = this.targetListSelect
        this.selectedStructure = this.listSelect
        this.structureItems = []
        this.$router.push(`/managestructure/create/${this.listSelect}`)
      } else if (action === 'saveAndStay') {
        await this.saveEditStructure(false)
        // this.structureItems = []
      } else if (action === 'saveAndBackToOrgchart') {
        await this.saveEditStructure(false)
        this.$router.push('/orgchart')
      } else if (action === 'stay' || action === 'cancel') {
      }
    },
    checkRemoveStructureItem (index) {
      this.structureItems.splice(index, 1)
    },
    async saveEditStructure (saveFromBtn) {
      var payload = {
        orgChartData: this.structureItems
      }
      // console.log('pfepf==', payload)
      const token = this.$store.state.token
      try {
        this.loading = true
        const res = await reqEditOrgChart(payload, token)
        if (res.success) {
          // console.log('req check', res)
          this.itemReq = res.result
          // console.log('***', this.itemReq)
        } else {
          console.log('req check fail')
          this.itemReq = {}
        }
        this.loading = false
      } catch (error) {
        console.log('req check fail', error)
      } finally {
        this.itemApprovers = this.itemLeaders
        this.companyForModal = this.structureItems.title
        this.showDetailOnEdit = true
      }
    },
    async saveSendReqEdit () {
      var payload = {
        orgChartData: this.structureItems
      }
      // console.log(payload)
      const token = this.$store.state.token
      try {
        const res = await updateOrgChart(payload, token)
        if (res.success) {
          // console.log('save success')
          this.snackbar = true
          setTimeout(() => { }, 2000)
        } else {
          console.log('save fail res')
        }
      } catch (error) {
        console.log('save fail', error)
      } finally {
      }
    },
    backToOverview () {
      if (this.structureItems.length) this.promtDialog = true
      else this.$router.push('/managestructure/companyDetail/' + this.companyId)
    }
  }
}
</script>

<style>
.title-main-text {
  font-family: Sarabun;
  font-style: normal;
  font-weight: bold;
  font-size: 16px;
  line-height: 24px;
  display: flex;
  align-items: center;
  color: #1654c6;
}

.title-sub-text {
  font-family: Sarabun;
  font-style: normal;
  font-weight: normal;
  font-size: 12px;
  line-height: 18px;
  display: flex;
  align-items: center;
  text-align: center;
  color: #757575;
}

.list-item-btn-selected {
  color: #3776e9;
  border-left: 3px solid #3776e9;
  border-radius: 0;
  font-weight: 450;
  font-size: 16px;
  width: 184px;
}

.list-item-btn {
  color: #333333;
  font-weight: 400;
  font-size: 16px;
  width: 184px;
  margin-left: 5px;
}

</style>
